import ICommand from "./ICommand";
import useMessageLogic from "../logic/useMessageLogic";
import {useAppDispatch, useAppSelector} from "../hooks";
import {addMember} from "../redux/members";
import {selectUser} from "../redux/auth";
import useApi from "../api/useApi";

export const useAddUserCommand = (): ICommand => {
  const messages = useMessageLogic()
  const user = useAppSelector(selectUser)
  const api = useApi()
  const dispatch = useAppDispatch()

  return {
    secure: true,

    help(): string {
      return '- adduser [USERNAME]\t\t\t:: adds a new member to the system';
    },

    async process(msg: string): Promise<void> {
      if (!user) {
        return
      }

      if (!user?.defaultSystemId) {
        messages.addErrorMessage('add system.name before adding members')
        return
      }

      const memberName = msg.substring('adduser '.length).trim()
      if (memberName !== '') {
        const member = await api.members.addMember(user.defaultSystemId, memberName)
        dispatch(addMember(member))
        messages.addSuccessMessage( `added new member '${memberName}'`)
      } else {
        messages.addErrorMessage('no member name provided')
      }
    },

    matches(msg: string): boolean {
      return msg.toLowerCase().trim().startsWith('adduser ')
    }
  };
}